import { defineMessages } from 'react-intl';

const messages = defineMessages({
  error265: {
    id: 'gofre.documentBAI.error.265.1219.message',
  },
  info: {
    id: 'gofre.documentBAI.error.message.info',
  },
  partialInfo: {
    id: 'gofre.documentBAI.error.message.partialInfo',
  },
  error1072: {
    id: 'gofre.documentBAI.error.10.72.message',
  },
});

export default messages;
